import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import getIcon from "../../utils/getIcon";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

export const formatPhone = (phone = "") => {
  let digits = phone.toString().replace(/\D/g, "");

  // +90 ile gelenler
  if (digits.startsWith("90") && digits.length <= 12) {
    return `+90 (${digits.slice(2, 5)}) ${digits.slice(5, 8)} ${digits.slice(8, 10)} ${digits.slice(10, 12)}`.trim();
  }

  // 0 ile başlayanlar
  if (digits.startsWith("0")) {
    return `0 (${digits.slice(1, 4)}) ${digits.slice(4, 7)} ${digits.slice(7, 9)} ${digits.slice(9, 11)}`.trim();
  }

  // 5 ile başlayanlar
  if (digits.startsWith("5")) {
    return `0 (${digits.slice(0, 3)}) ${digits.slice(3, 6)} ${digits.slice(6, 8)} ${digits.slice(8, 10)}`.trim();
  }

  return digits;
};

// ANA BİLEŞEN
const TabLeadsProfile = () => {
  const { id } = useParams();
  const [adminData, setAdminData] = useState(null);
  const [loading, setLoading] = useState(true);

  // Kullanıcının dilini al
  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, defaultValue) => translations[key] || defaultValue;

  // Admin bilgilerini çek
  useEffect(() => {
    const fetchAdminData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/leads/view/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
            },
          },
        );
        setAdminData(response.data);
      } catch (error) {
        console.error("❌ Admin bilgileri alınamadı:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchAdminData();
  }, [id]);

  if (loading) return <p>{getText("LOADING")}</p>;
  if (!adminData) return <p>{getText("NO_ADMIN_INFO")}</p>;

  const profileImageUrl = adminData.adminImage
    ? `${process.env.REACT_APP_API_BASE_URL}${adminData.adminImage}`
    : `${process.env.REACT_APP_API_BASE_URL}/uploads/avatars/default.svg`;
  console.log("🔍 Profil Resmi URL:", profileImageUrl);
  console.log("📌 API'den Gelen Admin Verisi:", adminData);

  //LEAD INFO
  const leadInfoData = [
    {
      title: getText("TABLE_NAME_LABEL"),
      content: <a href="#!">{adminData.name}</a>,
    },
    {
      title: getText("TABLE_EMAIL_LABEL"),
      content: <a href={`mailto:${adminData.email}`}>{adminData.email}</a>,
    },
    {
      title: getText("TABLE_PHONE_LABEL"),
      content: (
        <a href={`tel:${adminData.phone}`}>{formatPhone(adminData.phone)}</a>
      ),
    },
  ];

  //GENEL INFO
  const generalInfoData = [
    {
      title: getText("TABLE_ROLE_LABEL"),
      icon: "feather-user",
      text: adminData.role_name || getText("NOT_AVAILABLE"),
    },
    {
      title: getText("LABEL_CREATED_AT"),
      icon: "feather-clock",
      text: new Date(adminData.created_at).toLocaleDateString("en-GB"),
    },
  ];

  return (
    <div className="tab-pane fade show active" id="profileTab" role="tabpanel">
      <div className="card card-body lead-info">
        <div className="mb-4 d-flex align-items-center justify-content-between">
          <h5 className="fw-bold mb-0">
            <span className="d-block mb-2">{getText("ADMIN_INFO")}</span>
          </h5>
          <Link
            to={`/profile/edit/${id}`}
            className="btn btn-sm btn-light-brand"
          >
            {getText("EDIT")}
          </Link>
        </div>

        {/* Profil Fotoğrafı */}
        <div className="row mb-4 align-items-center">
          <div className="col-lg-2">
            <label className="fw-semibold">
              {getText("TABLE_PROFILE_IMAGE_LABEL")}
            </label>
          </div>
          <div className="col-lg-8">
            <div className="d-flex align-items-center gap-3">
              <img
                src={profileImageUrl}
                alt="Admin Profile"
                onError={(e) =>
                  (e.target.src = `${process.env.REACT_APP_API_BASE_URL}/uploads/avatars/default.svg`)
                }
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: "2px solid #ddd",
                  padding: "5px",
                }}
              />
            </div>
          </div>
        </div>

        {leadInfoData.map((data, index) => (
          <Card key={index} title={data.title} content={data.content} />
        ))}
      </div>
      <hr />
    </div>
  );
};

export default TabLeadsProfile;

// KÜÇÜK BİLEŞENLER

// Lead Kartı
const Card = ({ title, content }) => {
  return (
    <div className="row mb-4">
      <div className="col-lg-2 fw-medium">{title}</div>
      <div className="col-lg-10">{content}</div>
    </div>
  );
};
